import { describe, it, expect } from '@jest/globals';
import { compareSettings } from './compareSettings.js';

describe('compareSettings', () => {
  it('compares match.name when present with both match settings', () => {
    expect(compareSettings({ match: { name: 'foo', version: '1' } }, { match: { name: 'foo', version: '1' } })).toBe(0);
    expect(compareSettings({ match: { name: 'bar', version: '2' } }, { match: { name: 'foo', version: '1' } })).toBe(
      -1,
    );
    expect(compareSettings({ match: { name: 'foo', version: '1' } }, { match: { name: 'bar', version: '2' } })).toBe(1);
  });

  it('compares text when both match settings are strings', () => {
    expect(compareSettings({ match: 'bar' }, { match: 'foo' })).toBe(-1);
    expect(compareSettings({ match: 'foo' }, { match: 'bar' })).toBe(1);
  });

  it('places string matches at the beginning of the list', () => {
    expect(compareSettings({ match: 'foo' }, { match: { name: 'bar', version: '2' } })).toBe(-1);
    expect(compareSettings({ match: { name: 'bar', version: '2' } }, { match: 'foo' })).toBe(1);
  });

  // the semver package doesn't have a function to compare ranges, so we sort them alphabetically
  // (which at least is consistent)
  it('compares settings by version alphabetically if the names match', () => {
    expect(
      compareSettings({ match: { name: 'foo', version: '^1.0.0' } }, { match: { name: 'foo', version: '0.1.0' } }),
    ).toBe(-1);
    expect(
      compareSettings({ match: { name: 'foo', version: '0.1.0' } }, { match: { name: 'foo', version: '^1.0.0' } }),
    ).toBe(1);
  });
});
